import ModalForgotPassword from './ModalForgotPassword';

export default ModalForgotPassword;
